export default __webpack_public_path__ + "static/PAPC-843-52dd9f6f3de1916425c8d0817b64af9a.jpg";